














import {
  getServiceTaskDefaults,
  ServiceTaskDefault
} from "@/api/project/service-task-default-api";
import ServiceTaskDefaultTable from "@/components/project/property/ServiceTaskDefaultTable.vue";
import VToolbar from "@/components/VToolbar.vue";
import { Component, Vue } from "vue-property-decorator";

/**
 * 現場のプロパティキーの一覧ページ
 */
@Component({
  components: {
    VToolbar,
    ServiceTaskDefaultTable
  }
})
export default class ProjectPropertyTaskDefault extends Vue {
  data: ServiceTaskDefault[] = [];

  public created() {
    this.getData();
  }

  async getData() {
    this.data = await getServiceTaskDefaults();
  }
}
